import * as actions from './actions';
import SimpleArtist from '@common/types/artist/simple-artist';
import { SimpleOnboarding } from '@common/types/artist-onboarding/simple-onboarding';
import { LoadingAction } from '../common/loading-action';
import { ErrorAction } from '../common/error-action';
import { ArtistRelation } from '@common/types/artist/artist-relation';

export class CreateOnboarding implements LoadingAction {
  readonly type = actions.CREATE_ONBOARDING;
  readonly isLoading = true;

  constructor(
    public artist: SimpleArtist,
    public role: ArtistRelation['role']
  ) {}
}

export class CreateOnboardingSuccess implements LoadingAction {
  readonly type = actions.CREATE_ONBOARDING_SUCCESS;
  readonly isLoading = false;

  constructor(public onboarding: SimpleOnboarding) {}
}

export class CreateOnboardingError implements ErrorAction {
  readonly type = actions.CREATE_ONBOARDING_ERROR;
  readonly isError = true;

  constructor(public code: string) {}
}

export type OnboardingActions =
  | CreateOnboarding
  | CreateOnboardingSuccess
  | CreateOnboardingError;
